export default "__VITE_ASSET__J4bGVtlY__"